const countries = [
  { text: 'High-income countries (HICs)', value: 'hic' },
  { text: 'Australia', value: 'australia' },
  { text: 'Austria', value: 'austria' },
  { text: 'Belgium', value: 'belgium' },
  { text: 'Canada', value: 'canada' },
  { text: 'Denmark', value: 'denmark' },
  { text: 'Finland', value: 'finland' },
  { text: 'France', value: 'france' },
  { text: 'Germany', value: 'germany' },
  { text: 'Italy', value: 'italy' },
  { text: 'Japan', value: 'japan' },
  { text: 'The Netherlands', value: 'the-netherlands' },
  { text: 'Norway', value: 'norway' },
  { text: 'Portugal', value: 'portugal' },
  { text: 'Spain', value: 'spain' },
  { text: 'Sweden', value: 'sweden' },
  { text: 'Switzerland', value: 'switzerland' },
  { text: 'UK', value: 'uk' },
  { text: 'USA', value: 'usa' },
];

module.exports = countries;
// export default countries;
